import React from "react";
import { Spin } from "antd";
import { inject, observer } from "mobx-react";
import classnames from "classnames";
import { withRouter } from "react-router-dom";
import CreateTeamForm from "./createTeamForm";
import CreateTeamFormBBS from "./createTeamFormFromBBS";

import "./stylesheets/createTeam.scss";

@inject("languageStore", "gameStore", "commonStore", "teamStore", "authStore")
@withRouter
@observer
export default class CreateTeam extends React.Component {
  state = {
    isLoading: true
  };

  async componentDidMount() {
    if (!this.props.gameStore.selectedGame || !this.props.gameStore.selectedGame.id) {
      this.props.history.push("/registration-center");
    }
    this.setState({
      isLoading: true
    });
    await Promise.all([this.props.commonStore.getPca()]);
    this.props.teamStore.resetSchoolsInfo();
    this.setState({
      isLoading: false
    });
  }

  render() {
    if (!this.props.gameStore.selectedGame || !this.props.gameStore.selectedGame.id) {
      return null;
    }

    if (this.state.isLoading) {
      return (
        <div className="create-team empty">
          <Spin />
        </div>
      );
    }

    const isSpecialGame = this.props.gameStore.showTeamSloganGameCategoryId.includes(
      `${this.props.gameStore.selectedGame.attributes.category_id}`
    );

    // 选择的战队（论坛的战队）
    const selectedBBSTeam = this.props.authStore.bbsTeamList.find(
      item => item.id === this.props.teamStore.currentSelectBBSTeamId
    );

    return (
      <div className={classnames("create-team", this.props.languageStore.lang)}>
        {/* 这样做的目的是只有UC和UL才从论坛获取战队，其余比赛仍走老逻辑，直接新增一个CreateTeamFormBBS，最大程度减少对老逻辑的影响 */}
        {isSpecialGame && selectedBBSTeam ? (
          <CreateTeamFormBBS
            isSpecialGame={isSpecialGame}
            selectedBBSTeam={selectedBBSTeam}
            eventId={this.props.gameStore.selectedGame.id}
          />
        ) : (
          <CreateTeamForm eventId={this.props.gameStore.selectedGame.id} />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/createTeam/createTeam.js